import React, {Component} from "react";
import {IconButton, Stack, Tooltip} from "@mui/material";
import {ScreenshotMonitorTwoTone, ScreenshotTwoTone} from "@mui/icons-material";
import {morphleBaseTheme1} from "../themes";
import {downloadScreenshot, takeScreenshot} from "../utils/screenshot_utils";
import {connect} from "react-redux";
import {componentIds, responsiveLayers} from "../../../utils/const";
import {updateZStackLevel} from "../../../redux_actions/maps.state.action";
import {updateBarcodeImgRotation} from "../../../redux_actions/screenshot.state.action";
import {message} from "antd";
import {get, post} from "../../../helper/request";
import {error_manager} from "../../../helper/error_manager";
import {GLOBAL_CONFIG} from "../../../utils/enums"
import {getPrefixedUrlSecure, notNull, sleep, uuid} from "../../../utils/utils";
import {getDicomThumbnails, getGlobalConfig} from "../../../utils/api";
import {getViewLevelsInfo, isMobile, isOpenLayersMap, isZoomForTiled} from "../utils/map_utils";
import {requestOsdFeature} from "../openseadragon/viewerSelection";
import {DragPan, KeyboardPan, MouseWheelZoom} from "ol/interaction";

class Screenshot extends Component {

	constructor(props) {
		super(props);

		this.state = {
			spinning: false,
			imageData: null
		}

		this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
			(document.documentElement.clientWidth < document.documentElement.clientHeight);
	}

	componentDidMount() {
		this.getBarcodeImageRotation();
		if (this.props.is_dicom) {
            getDicomThumbnails(this.props.slide.id, true)
                .then(data => this.setState({imageData: data}))
                .catch(err => {
                    this.setState({imageData: ''})
					error_manager("Failed to fetch thumbnail", err)
                })
        }
		
	}

	getBarcodeImageRotation = () => {
		getGlobalConfig().then(response => {
            if (response.status === 200) {
                if (notNull(response.data[GLOBAL_CONFIG.BARCODE_ROTATION_VIEWER.key])) {
                    this.props.dispatch(updateBarcodeImgRotation(response.data[GLOBAL_CONFIG.BARCODE_ROTATION_VIEWER.key]))
                } else {
                    this.props.dispatch(updateBarcodeImgRotation(270))
                }
            }
        }).catch(err => error_manager("Failed to fetch key", err))
	}

	toggleInteractionsOnMap = (map, enable) => {
		if (!isOpenLayersMap(map)) return;
		let interactions = map.getInteractions();
		interactions.forEach(function(interaction) {
			if (interaction instanceof DragPan || interaction instanceof KeyboardPan || interaction instanceof MouseWheelZoom) {
				interaction.setActive(enable);
			}
		});
	}

	initData = () => {
		this.activeMapId = this.props.activeMapId;
	}

	registerZStackScreenshot = (blob, metadata) => {
		let formData = new FormData();
		formData.append('file', blob, metadata["zLevel"]);
		formData.append('slide', metadata["slide_id"]);
		formData.append('type', metadata["ext"]);
		formData.append("id", metadata["uuid"]);
		formData.append("zLevel", metadata["zLevel"]);
		formData.append("folder_name", metadata["folder_name"])
		post('/api/register_zstack_screenshot/', formData).then(() => {
		}).catch((err) => error_manager("Error adding screenshot to report", err));
	}

	changeZLevelAndTakeScreenshot = async () => {
		try {
			message.info("Collecting all z-level images, please don't move scan");
			this.setState({spinning: true});
			let id = uuid();
			let name = Math.random().toString(36).substring(2, 6);
			let maxZLevel = this.props.slide.meta?.takeBidirectionalZStack ?
				(this.props.slide.meta?.numZLevels - 1) / 2 : (this.props.slide.meta?.numZLevels - 1);
			let minZLevel = this.props.slide.meta?.takeBidirectionalZStack ?
				(-1 * ((this.props.slide.meta?.numZLevels - 1) / 2)) : 0;

			this.props.dispatch(updateZStackLevel(this.props.activeMapId, Math.floor(minZLevel)))
			await sleep(500);
			downloadScreenshot(componentIds.slideMaps,
				this.props.slide.name, this.props.extension, this.props.displaySetting)
			this.toggleInteractionsOnMap(this.props.slidemap, false);
			for (let zLevel = Math.floor(minZLevel); zLevel <= Math.floor(maxZLevel); zLevel++) {
				this.props.dispatch(updateZStackLevel(this.props.activeMapId, zLevel))
				await sleep(1500);
				takeScreenshot(componentIds.slideMaps, this.props.extension, this.props.displaySetting, (blob) => {
					this.registerZStackScreenshot(blob, {"zLevel": zLevel, "slide_id": this.props.slide.id, "uuid": id, "ext": this.props.extension, "folder_name": name})
				})
			}

			get(`/api/do_focus_stacking/?folder_name=${name}&slide_id=${this.props.slide.id}`)
				.then(result => message.success("Images collected, focus stacked image will be available in screenshot app (It can take few mins)."))
				.catch((err) => {
                    error_manager("Some error occurred in doing focus stacking", err)
				})
		} catch (err) {
			console.error("Error in taking z-stack screenshot: ", err);
			message.error("Some error occurred in taking z-stack screenshot.");
		} finally {
			this.setState({spinning: false});
			this.toggleInteractionsOnMap(this.props.slidemap, true);
		}

	}

	render() {
		this.initData();
		if (!this.props.slide) return <div/>;

		const mobileScreenshotStyling = {
			backgroundColor: '#330470',
			color: 'white',
			borderRadius: '50px',
			height: '40px',
			width: '40px',
			opacity: 0.8,
			padding: '5px'
		}
		let onStichedLevel = !isZoomForTiled(this.props.slidemap.getView().getZoom(), getViewLevelsInfo(this.props.slide));

		return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
			<Tooltip title={"Screenshot"} placement={"bottom"} className='screenshot-forTour'>
				<IconButton size="small" onClick={() => {
					downloadScreenshot(componentIds.slideMaps,
						this.props.slide.name, this.props.extension, this.props.displaySetting, 
						this.props.morpheusSetting.abstract_configs.add_barcode_in_screenshot === true ? (this.props.is_dicom ? this.state.imageData : getPrefixedUrlSecure(`pre-processed/barcode_crop.jpg`, this.props.slide)): null,
						this.props.barcodeImgCurrentRotation)
				}}>
					<ScreenshotTwoTone
						sx={this.isMobile ? mobileScreenshotStyling : {color: morphleBaseTheme1.palette.headBarIcon.primary}}/>
				</IconButton>
			</Tooltip>

			{this.props.slide?.meta?.takeZStack && this.props.zStackScreenshotEnabled && !isMobile() ?
				<Tooltip title={"ZStack-Screenshot"} placement={"bottom"} className='screenshotzStack-forTour'>
					<IconButton size="small" onClick={() => requestOsdFeature('z_stack')
						.then(proceed => proceed && this.changeZLevelAndTakeScreenshot())}
								disabled={onStichedLevel}>
						<ScreenshotMonitorTwoTone
							sx={this.isMobile ? mobileScreenshotStyling : {color: morphleBaseTheme1.palette.headBarIcon.primary}}/>
					</IconButton>
				</Tooltip> : null}
		</Stack>
	}
}


const mapStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {extension, zStackScreenshotEnabled, barcodeImgCurrentRotation} = state.screenshotStateReducer;
	let {slide, displaySetting, zStackLevel, slidemap, z, is_dicom} = state.mapsStateReducer[activeMapId];
	let morpheusSetting = state.morpheusSettingReducer;
	return {activeMapId, slide, slidemap, displaySetting, extension, zStackLevel, zStackScreenshotEnabled, z, barcodeImgCurrentRotation, morpheusSetting, is_dicom};
}
export default connect(mapStateToProps)(Screenshot)
